module.exports = __webpack_public_path__ + "static/img/joinBanner1.71b895f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/join/joinBanner1.jpg
// module id = XCqU
// module chunks = 0